import React from 'react';
import useTextOverlayFontStyles from 'blocks/TextOverlayModal/v2/hooks/useTextOverlayFontStyles';
import AnimationColorSelector from '../../AnimationColorSelector';

export interface KaraokeAnimationWordPastColorSelectorProps {}

const KaraokeAnimationWordPastColorSelector: React.FC<KaraokeAnimationWordPastColorSelectorProps> = () => {
  const { selectedFontColor, onChangeFontColor } = useTextOverlayFontStyles();

  return (
    <AnimationColorSelector
      title="past word color"
      color={selectedFontColor}
      onChange={onChangeFontColor}
    />
  );
};

export default KaraokeAnimationWordPastColorSelector;
